import { trackEvent, trackEventGA4 } from '../gtm';
import { trackSignUpEvent } from '../../components/dwh-tracking/api';

const DEFAULT_TRACK_DELAY = 5000;

export const trackSignUpStart = () => {
    setTimeout(() => {
        trackEventGA4('sign_up_start', { sign_up_phase: 1 });
        trackEventGA4('sign_up_prospect_shown', { sign_up_phase: 1 });
        trackSignUpEvent('sign_up_prospect_shown', 1, null);
    }, DEFAULT_TRACK_DELAY);
};
export const trackSignUpPhoneVerificationShown = prospectId => {
    setTimeout(() => {
        trackEventGA4('sign_up_phone_verification_shown', { sign_up_phase: 2 });
        trackSignUpEvent('sign_up_phone_verification_shown', 2, prospectId);
    }, DEFAULT_TRACK_DELAY);
};

export const trackSignUpPhoneChangeShown = prospectId => {
    setTimeout(() => {
        trackEventGA4('sign_up_phone_change_shown', { sign_up_phase: 2 });
        trackSignUpEvent('sign_up_phone_change_shown', 2, prospectId);
    }, DEFAULT_TRACK_DELAY);
};

export const trackSignUpEmailVerificationShown = prospectId => {
    setTimeout(() => {
        trackEventGA4('sign_up_email_verification_shown', { sign_up_phase: 3 });
        trackSignUpEvent('sign_up_email_verification_shown', 3, prospectId);
    }, DEFAULT_TRACK_DELAY);
};

export const trackSignUpEmailSentShown = prospectId => {
    setTimeout(() => {
        trackEventGA4('sign_up_form_submitted', { sign_up_phase: 3 });
        trackEventGA4('sign_up_email_verification_sent_shown', { sign_up_phase: 3 });
        trackSignUpEvent('sign_up_email_verification_sent_shown', 3, prospectId);
    }, DEFAULT_TRACK_DELAY);
};

// TODO: Odstranit po spusteni biometrickeho overenia
export const trackSignUpUsernamePasswordShown = prospectId => {
    setTimeout(() => {
        trackEventGA4('sign_up_finished', { sign_up_phase: 4 });
        trackEventGA4('sign_up_username_password_shown', { sign_up_phase: 4 });
        trackSignUpEvent('sign_up_username_password_shown', 4, prospectId);
    }, DEFAULT_TRACK_DELAY);
};

export const trackSignUpSuccessShown = prospectId => {
    setTimeout(() => {
        trackEventGA4('sign_up_success_shown', { sign_up_phase: 5 });
        trackSignUpEvent('sign_up_success_shown', 5, prospectId);
    }, DEFAULT_TRACK_DELAY);
};

export const trackSignUpDocsUploaded = () => {
    setTimeout(() => {
        trackEventGA4('sign_up_docs_uploaded', { sign_up_phase: 6 });
        trackEventGA4('sign_up_docs_uploaded_shown', { sign_up_phase: 6 });
        trackSignUpEvent('sign_up_docs_uploaded_shown', 6, null);
    }, DEFAULT_TRACK_DELAY);
};

export const trackLoginEvent = () => {
    setTimeout(() => {
        trackEvent('LOGIN', window.location.pathname);
        trackEventGA4('login');
    }, DEFAULT_TRACK_DELAY);
};
